import { selectIElementsSlice } from "@/store/ielements-slice-selector";
import { curryAppSelector } from "@/store/reselect";
import {
  IElementProjectRoot,
  IElementUnassigned2dPhoto,
  isIElementUnassigned2dPhoto,
  isIElementUnassigned2dPhotosGroup,
} from "@faro-lotv/ielement-types";
import {
  IElementsState,
  selectChildDepthFirst,
  selectChildrenDepthFirst,
  selectRootIElement,
} from "@faro-lotv/project-source";
import { createSelector } from "@reduxjs/toolkit";

/**
 * Selector to get the list of unassigned 2D photos in the project
 */
export const selectUnassigned2dPhotos = curryAppSelector(
  createSelector(
    [selectIElementsSlice, selectRootIElement],
    (
      iElements: IElementsState,
      rootElement: IElementProjectRoot | undefined,
    ): IElementUnassigned2dPhoto[] => {
      // First, find the parent element that holds unassigned 2D photos
      const state = { iElements };
      const unassigned2dPhotosParent = selectChildDepthFirst(
        rootElement,
        isIElementUnassigned2dPhotosGroup,
      )(state);
      if (!unassigned2dPhotosParent) {
        return [];
      }

      // Then, get all children of that parent that are 2D photos
      return selectChildrenDepthFirst(
        unassigned2dPhotosParent,
        isIElementUnassigned2dPhoto,
      )(state);
    },
  ),
);
